var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByOpshelm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7629 8.35742L8.44405 12.6711C8.32496 12.7898 8.16363 12.8565 7.99544 12.8565C7.82725 12.8565 7.66592 12.7898 7.54683 12.6711L3.22281 8.35742H0.500031C0.499205 8.44055 0.515078 8.523 0.546707 8.59988C0.578008 8.67685 0.624787 8.74658 0.684142 8.80473L7.54813 15.6519C7.60616 15.712 7.67587 15.7597 7.75298 15.7919C7.83019 15.8242 7.91303 15.841 7.99674 15.8412C8.08047 15.8412 8.16336 15.8245 8.24049 15.7919C8.3176 15.7597 8.38732 15.712 8.44535 15.6519L15.3158 8.80473C15.3751 8.74629 15.4223 8.67666 15.4545 8.59988C15.4858 8.52292 15.5012 8.44046 15.4999 8.35742H12.7629Z",
    fill: "url(#paint0_linear_9100_41696)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3133 7.19302C15.3695 7.2522 15.4135 7.32179 15.443 7.39787C15.4748 7.47478 15.4915 7.5571 15.4922 7.64033H9.56567L7.92293 7.62218C7.92293 7.62218 7.01534 7.64551 6.32297 7.64551H3.23068H0.507903C0.506456 7.56233 0.522352 7.47976 0.554579 7.40306C0.585881 7.32608 0.632659 7.25636 0.692015 7.1982L3.06342 4.82679L4.58818 3.30334L7.54433 0.345884C7.60278 0.286557 7.67241 0.239405 7.74919 0.207153C7.82659 0.175597 7.90936 0.159307 7.99294 0.15918C8.07609 0.159474 8.1584 0.175761 8.2354 0.207153C8.31258 0.239376 8.38264 0.286522 8.44155 0.345884L11.4236 3.32019L12.9704 4.85921L15.3133 7.19302Z",
    fill: "#2F3259"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9100_41696",
    x1: 8,
    y1: 8.35742,
    x2: 8,
    y2: 15.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5712F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByOpshelm);
export default __webpack_public_path__ + "static/media/byOpshelm.7d58b1359ee3be4cdf79819c36f8b915.svg";
export { ForwardRef as ReactComponent };